module.exports = __webpack_public_path__ + "static/img/synthe2.1d67208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/synthe2.png
// module id = 3mBP
// module chunks = 2